// Registers the Scaffold skin's UI elements and its icons. The players come from videojs_players, imported first.
// Kept out of the layout packs so the skin elements and icons only register on pages that import this module.
// Styles come from app/assets/tailwind/videojs/scaffold.css (imported by application.css), so no CSS is imported here.
// The ui/* list is the union of what the @videojs/html 10.2.0 Scaffold video and live-video skins import.
import "videojs_players";
import "@videojs/html/media/hlsjs-video";
import "@videojs/html/i18n";
import "@videojs/html/ui/airplay-button";
import "@videojs/html/ui/audio-track-radio-group";
import "@videojs/html/ui/buffering-indicator";
import "@videojs/html/ui/captions-button";
import "@videojs/html/ui/captions-radio-group";
import "@videojs/html/ui/cast-button";
import "@videojs/html/ui/container";
import "@videojs/html/ui/controls";
import "@videojs/html/ui/controls-backdrop";
import "@videojs/html/ui/controls-content";
import "@videojs/html/ui/controls-group";
import "@videojs/html/ui/dialog-backdrop";
import "@videojs/html/ui/dialog-close";
import "@videojs/html/ui/dialog-description";
import "@videojs/html/ui/dialog-popup";
import "@videojs/html/ui/dialog-title";
import "@videojs/html/ui/error-dialog";
import "@videojs/html/ui/fullscreen-button";
import "@videojs/html/ui/gesture";
import "@videojs/html/ui/hotkey";
import "@videojs/html/ui/menu";
import "@videojs/html/ui/menu-content";
import "@videojs/html/ui/menu-item";
import "@videojs/html/ui/menu-item-indicator";
import "@videojs/html/ui/menu-radio-item";
import "@videojs/html/ui/menu-separator";
import "@videojs/html/ui/mute-button";
import "@videojs/html/ui/pip-button";
import "@videojs/html/ui/play-button";
import "@videojs/html/ui/playback-rate-radio-group";
import "@videojs/html/ui/poster";
import "@videojs/html/ui/quality-radio-group";
import "@videojs/html/ui/seek-button";
import "@videojs/html/ui/seek-indicator";
import "@videojs/html/ui/seek-indicator-value";
import "@videojs/html/ui/slider-buffer";
import "@videojs/html/ui/slider-fill";
import "@videojs/html/ui/slider-preview";
import "@videojs/html/ui/slider-thumb";
import "@videojs/html/ui/slider-thumbnail";
import "@videojs/html/ui/slider-track";
import "@videojs/html/ui/slider-value";
import "@videojs/html/ui/status-announcer";
import "@videojs/html/ui/status-indicator";
import "@videojs/html/ui/status-indicator-value";
import "@videojs/html/ui/time";
import "@videojs/html/ui/time-group";
import "@videojs/html/ui/time-separator";
import "@videojs/html/ui/time-slider";
import "@videojs/html/ui/time-slider-chapter-title";
import "@videojs/html/ui/time-slider-chapters";
import "@videojs/html/ui/title";
import "@videojs/html/ui/tooltip";
import "@videojs/html/ui/tooltip-group";
import "@videojs/html/ui/tooltip-label";
import "@videojs/html/ui/tooltip-shortcut";
import "@videojs/html/ui/volume-indicator";
import "@videojs/html/ui/volume-indicator-fill";
import "@videojs/html/ui/volume-indicator-value";
import "@videojs/html/ui/volume-popover";
import "@videojs/html/ui/volume-slider";
import { registerIcons } from "@videojs/html/icons";
import {
  airPlayEnterIcon,
  airPlayExitIcon,
  captionsOffIcon,
  captionsOnIcon,
  castEnterIcon,
  castExitIcon,
  checkIcon,
  chevronIcon,
  fullscreenEnterIcon,
  fullscreenExitIcon,
  gearIcon,
  pauseIcon,
  pipEnterIcon,
  pipExitIcon,
  playIcon,
  restartIcon,
  seekIcon,
  speechIcon,
  speedIcon,
  spinnerIcon,
  switchesIcon,
  volumeHighIcon,
  volumeLowIcon,
  volumeOffIcon
} from "@videojs/html/icons/compat";

registerIcons('scaffold', {
  "airplay-enter": airPlayEnterIcon,
  "airplay-exit": airPlayExitIcon,
  "captions-off": captionsOffIcon,
  "captions-on": captionsOnIcon,
  "cast-enter": castEnterIcon,
  "cast-exit": castExitIcon,
  check: checkIcon,
  chevron: chevronIcon,
  "fullscreen-enter": fullscreenEnterIcon,
  "fullscreen-exit": fullscreenExitIcon,
  gear: gearIcon,
  pause: pauseIcon,
  "pip-enter": pipEnterIcon,
  "pip-exit": pipExitIcon,
  play: playIcon,
  restart: restartIcon,
  seek: seekIcon,
  speech: speechIcon,
  speed: speedIcon,
  spinner: spinnerIcon,
  switches: switchesIcon,
  "volume-high": volumeHighIcon,
  "volume-low": volumeLowIcon,
  "volume-off": volumeOffIcon
});
